document.addEventListener("DOMContentLoaded", () => {
  // Session helpers to avoid repeated popups within the same browser session
  const STORAGE_KEY = "freeShippingPopupState";
  const readState = () => {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}"); }
    catch (e) { return {}; }
  };
  const writeState = (patch = {}) => {
    try {
      const s = { ...(readState()), ...patch };
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(s));
    } catch (e) { /* ignore */ }
  };
  const clearDismissedIfCartChanged = (cartHash) => {
    const s = readState();
    if (s.cartHash !== cartHash) {
      writeState({ cartHash, dismissedMessageKey: null });
    }
  };
  const messageKeyFor = (message) => `${message.main}|${message.sub}`;

  // Función para crear y actualizar la ventana emergente
  const createOrUpdatePopup = (message, meta = {}) => {
    let popup = document.getElementById("freeShippingPopup");
    const isCartPage = document.getElementById("checkout-submit") || document.querySelector("a[href='/cart'].button-outline");
    
    if (!popup) {
      popup = document.createElement("div");
      popup.id = "freeShippingPopup";
      // Use a desktop breakpoint to avoid full-width popup on large screens
      const isDesktop = window.innerWidth >= 992;
      let positionStyle;
      if (isCartPage) {
        // On cart page, center the popup; constrain width on desktop, full width on mobile
        if (isDesktop) {
          positionStyle = `position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); max-width: 720px; width: calc(100% - 120px);`;
        } else {
          positionStyle = `position: fixed; top: 50%; left: 0; right: 0; transform: translateY(-50%); width: 100%;`;
        }
      } else {
        // Non-cart pages: bottom-right toast
        positionStyle = `position: fixed; bottom: 20px; left: 20px; right: 20px; width: auto;`;
      }
      
      popup.style.cssText = `
          ${positionStyle}
          background-color: #f0fdf4;
          color: #15803d;
          padding: 20px;
          border-radius: 10px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          z-index: 9999;
          display: flex;
          align-items: center;
          gap: 12px;
          border: 1px solid #bbf7d0;
          box-sizing: border-box;
        `;
      // Agregar icono
      const giftIcon = document.createElement("img");
      giftIcon.src =
        "https://cdn.jsdelivr.net/npm/lucide-static@latest/icons/gift.svg";
      giftIcon.alt = "Regalo";
      giftIcon.style.width = "24px";
      giftIcon.style.height = "24px";
      giftIcon.style.flexShrink = "0";
      popup.appendChild(giftIcon);

      // Contenedor de texto con estructura mejorada
      const textContainer = document.createElement("div");
      textContainer.style.cssText = `
        display: flex;
        flex-direction: column;
        gap: 4px;
        flex: 1;
      `;
      
      const mainText = document.createElement("div");
      mainText.style.cssText = `
        font-weight: 700;
        font-size: 0.95em;
        line-height: 1.3;
        color: #15803d;
        margin: 0;
        padding: 0;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        white-space: normal;
      `;
      
      const subText = document.createElement("div");
      subText.style.cssText = `
        font-weight: 400;
        font-size: 0.85em;
        opacity: 0.85;
        line-height: 1.2;
        color: #15803d;
        margin: 0;
        padding: 0;
      `;
      
      textContainer.appendChild(mainText);
      textContainer.appendChild(subText);
      popup.appendChild(textContainer);
      
      // Guardar referencias para actualizar
      popup.mainText = mainText;
      popup.subText = subText;
      
      // Asignar contenido inicial
      popup.mainText.textContent = message.main;
      popup.subText.textContent = message.sub;

      // Botón de cerrar (opcional)
      const closeButton = document.createElement("button");
      closeButton.textContent = "Cerrar";
      closeButton.style.cssText = `
          margin-left: auto;
          background-color: transparent;
          border: none;
          color: #15803d;
          cursor: pointer;
          font-size: 0.9em;
          padding: 6px 10px;
          border-radius: 6px;
        `;
      
      const removePopup = () => {
        // store dismissed key so same message isn't shown again for this cart
        if (meta.messageKey) {
          try {
            writeState({ dismissedMessageKey: meta.messageKey, lastMessageKey: meta.messageKey, lastShownAt: Date.now(), cartHash: meta.cartHash || readState().cartHash });
          } catch (e) { /* ignore */ }
        }
        popup.remove();
        // Remove scroll listener when popup is removed
        document.removeEventListener("scroll", removePopup);
      }; 
      
      closeButton.addEventListener("click", removePopup);
      popup.appendChild(closeButton);

      document.body.appendChild(popup);
      
      // Auto-dismiss: 4 seconds for free shipping message, 6 seconds for "need more" message
      const dismissTime = message.main?.includes("¡ENVÍO GRATIS") ? 4000 : 6000;
      setTimeout(removePopup, dismissTime);
      
      // Dismiss on scroll
      document.addEventListener("scroll", removePopup);
    } else {
      // Actualizar el mensaje si la ventana emergente ya exista
      popup.mainText.textContent = message.main;
      popup.subText.textContent = message.sub;
      // Recalculate responsive positioning (in case viewport changed)
      const isDesktop = window.innerWidth >= 992;
      if (isCartPage) {
        if (isDesktop) {
          popup.style.left = '50%';
          popup.style.top = '50%';
          popup.style.right = 'auto';
          popup.style.transform = 'translate(-50%, -50%)';
          popup.style.maxWidth = '720px';
          popup.style.width = 'calc(100% - 120px)';
          popup.style.bottom = '';
        } else {
          popup.style.left = '0';
          popup.style.right = '0';
          popup.style.top = '50%';
          popup.style.transform = 'translateY(-50%)';
          popup.style.width = '100%';
          popup.style.maxWidth = '';
          popup.style.bottom = '';
        }
      } else {
        popup.style.bottom = '20px';
        popup.style.left = '20px';
        popup.style.right = '20px';
        popup.style.top = '';
        popup.style.transform = '';
        popup.style.width = 'auto';
        popup.style.maxWidth = '';
      }
    }
  };

  const checkCartAndShowPopup = () => {
    // Obtener el subtotal del carrito
    fetch("/cart.json")
      .then((response) => response.json())
      .then((cart) => {
        const subtotal = cart.total_price / 100; // Convertir a euros
        const freeShippingThreshold = 120;

        // Create a small stable cart hash so we can detect changes
        const cartHash = `${cart.total_price}-${cart.items.length}-${cart.items.map(i => `${i.variant_id}x${i.quantity}`).join("|")}`;
        clearDismissedIfCartChanged(cartHash);

        const amountLeft = Math.max(0, freeShippingThreshold - subtotal);
        const roundedLeft = Math.ceil(amountLeft); // avoid tiny differences re-triggering popups
        const itemCount = cart.items.length; // Obtener el número de items en el carrito

        // build message based on roundedLeft
        if (subtotal < freeShippingThreshold && itemCount > 0) {
          let message = { main: "", sub: "" };
          
          if (roundedLeft > 50) {
            message.main = `Solo ${roundedLeft}€ para ENVÍO GRATIS`;
            message.sub = "Explora más productos";
          } else if (roundedLeft > 20) {
            message.main = `¡Casi! ${roundedLeft}€ para ENVÍO GRATIS`;
            message.sub = "Muy cerca del envío gratis";
          } else {
            message.main = `¡Facilísimo! Solo ${roundedLeft}€ para ENVÍO GRATIS`;
            message.sub = "Una última cosa...";
          }

          const messageKey = messageKeyFor(message);
          const state = readState();

          // don't re-show if user dismissed this exact message for this cart
          if (state.dismissedMessageKey === messageKey) return;
          // don't re-show if same message already shown this session (e.g. page reload or clicking cart)
          if (state.lastMessageKey === messageKey) return;

          createOrUpdatePopup(message, { messageKey, cartHash });
          writeState({ lastMessageKey: messageKey, lastShownAt: Date.now(), cartHash, lastSubtotal: subtotal });
        } else if (subtotal >= freeShippingThreshold && itemCount > 0) {
          // If crossing into free shipping, show once
          const message = {
            main: "🎁 ¡ENVÍO GRATIS!",
            sub: "A Península y Baleares"
          };
          const messageKey = messageKeyFor(message);
          const state = readState();

          // show only if not already shown/dismissed
          if (state.dismissedMessageKey === messageKey) return;
          if (state.lastMessageKey === messageKey) return;

          createOrUpdatePopup(message, { messageKey, cartHash });
          writeState({ lastMessageKey: messageKey, lastShownAt: Date.now(), cartHash, lastSubtotal: subtotal });
        } else {
          // remove popup if cart empty or subtotal below threshold and nothing to display
          const popup = document.getElementById("freeShippingPopup");
          if (popup) {
            popup.remove();
          }
        }
      })
      .catch((error) => {
        console.error("Error al obtener el carrito:", error);
      });
  };

  // Verificar el carrito al cargar la página y cada vez que se actualiza
  checkCartAndShowPopup();

  // Clear dismissed message state when cart is changed (items added/removed)
  document.addEventListener("eurus:cart:items-changed", () => {
    // quick clear so we can show new message if appropriate after changes
    const s = readState();
    if (s) writeState({ dismissedMessageKey: null });
    setTimeout(checkCartAndShowPopup, 500);
  });
});